namespace Matrix.Data {
    export interface TestResultRow {
        BatchId?: number;
        TestCode?: string;
        ResultCode?: string;
        ResultSignature?: number[];
        FailCount?: number;
        Message?: string;
        ResultData?: string;
        ResultId?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        BatchBatchDate?: string;
        BatchBatchCode?: string;
        BatchStartedBy?: string;
        BatchStartedWhen?: string;
        BatchFinishedWhen?: string;
        BatchDurationSeconds?: number;
        BatchSuccess?: boolean;
        TestCodeDescription?: string;
        TestCodeEnabled?: boolean;
        TestCodeTestTypeCode?: string;
        TestCodePriority?: string;
        TestCodeScript?: string;
        TestCodeLastRunBatchId?: number;
        TestCodeLastResultCode?: string;
        TestCodeRowId?: number;
        TestCodeVersion?: number;
        TestCodeCreatedBy?: string;
        TestCodeCreatedWhen?: string;
        TestCodeUpdatedBy?: string;
        TestCodeUpdatedWhen?: string;
        MuteId?: number;
        MuteUntil?: string;
        MuteComment?: string;
    }

    export namespace TestResultRow {
        export const idProperty = 'ResultId';
        export const nameProperty = 'TestCode';
        export const localTextPrefix = 'Data.TestResult';
        export const deletePermission = 'NoPermission';
        export const insertPermission = 'NoPermission';
        export const readPermission = 'Read:TestResult';
        export const updatePermission = 'NoPermission';

        export declare const enum Fields {
            BatchId = "BatchId",
            TestCode = "TestCode",
            ResultCode = "ResultCode",
            ResultSignature = "ResultSignature",
            FailCount = "FailCount",
            Message = "Message",
            ResultData = "ResultData",
            ResultId = "ResultId",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            BatchBatchDate = "BatchBatchDate",
            BatchBatchCode = "BatchBatchCode",
            BatchStartedBy = "BatchStartedBy",
            BatchStartedWhen = "BatchStartedWhen",
            BatchFinishedWhen = "BatchFinishedWhen",
            BatchDurationSeconds = "BatchDurationSeconds",
            BatchSuccess = "BatchSuccess",
            TestCodeDescription = "TestCodeDescription",
            TestCodeEnabled = "TestCodeEnabled",
            TestCodeTestTypeCode = "TestCodeTestTypeCode",
            TestCodePriority = "TestCodePriority",
            TestCodeScript = "TestCodeScript",
            TestCodeLastRunBatchId = "TestCodeLastRunBatchId",
            TestCodeLastResultCode = "TestCodeLastResultCode",
            TestCodeRowId = "TestCodeRowId",
            TestCodeVersion = "TestCodeVersion",
            TestCodeCreatedBy = "TestCodeCreatedBy",
            TestCodeCreatedWhen = "TestCodeCreatedWhen",
            TestCodeUpdatedBy = "TestCodeUpdatedBy",
            TestCodeUpdatedWhen = "TestCodeUpdatedWhen",
            MuteId = "MuteId",
            MuteUntil = "MuteUntil",
            MuteComment = "MuteComment"
        }
    }
}
